"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DimensionRow = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var styled_components_1 = __importDefault(require("styled-components"));
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var models_1 = require("../../models");
var enum_1 = require("../../models/enum");
var DimensionViewColumnHelper_1 = require("../../utilities/columns/DimensionViewColumnHelper");
var common_1 = require("../common");
var QuestionTable_1 = require("../questions/QuestionTable");
var DimensionTableColumn_1 = require("./DimensionTableColumn");
var DimensionTableRow_1 = require("./DimensionTableRow");
var ExpandContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground-color: #ffffff;\n\t&.table.table tbody tr td:first-child {\n\t\tbackground: #ffffff;\n\t}\n"], ["\n\tbackground-color: #ffffff;\n\t&.table.table tbody tr td:first-child {\n\t\tbackground: #ffffff;\n\t}\n"])));
var DimensionNameCell = (0, styled_components_1.default)(DimensionTableColumn_1.DimensionTableColumn)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 200px;\n"], ["\n\twidth: 200px;\n"])));
DimensionNameCell.displayName = 'DimensionNameCell';
var DimensionCountCell = (0, styled_components_1.default)(DimensionTableColumn_1.DimensionTableColumn)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 175px;\n"], ["\n\twidth: 175px;\n"])));
DimensionCountCell.displayName = 'DimensionCountCell';
var DimensionRow = /** @class */ (function (_super) {
    __extends(DimensionRow, _super);
    function DimensionRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isExpanded: false };
        _this.getQuestionPropertyText = _this.getQuestionPropertyText.bind(_this);
        _this.GetMissingLanguages = _this.GetMissingLanguages.bind(_this);
        _this.ToggleExpanded = _this.ToggleExpanded.bind(_this);
        _this.getEditExpandableRowRender = _this.getEditExpandableRowRender.bind(_this);
        return _this;
    }
    DimensionRow.prototype.render = function () {
        var _this = this;
        return (React.createElement(DimensionTableRow_1.DimensionTableRow, { isOpen: this.state.isExpanded, OnOpen: this.ToggleExpanded, expanded: this.state.isExpanded, expandedRowRender: this.getEditExpandableRowRender }, this.props.dimensionColumns.map(function (c) { return _this.getQuestionPropertyText(c); })));
    };
    DimensionRow.prototype.getEditExpandableRowRender = function () {
        return (React.createElement(aon_tws_common_ui_1.TableColumn, { colSpan: this.props.dimensionColumns.length + 1 },
            React.createElement(ExpandContainer, null,
                React.createElement(QuestionTable_1.QuestionTable, __assign({}, this.props, { totalSelectedQuestions: this.props.selectedCustomQuestionIds.length, shouldRemovePaging: true, showFilterOption: false, shouldRemoveToolMenu: true, hideLanguageModalIcon: this.props.hideLanguageModalIcon })))));
    };
    DimensionRow.prototype.getQuestionPropertyText = function (column) {
        var _this = this;
        var dimension = this.props.dimension;
        var key = dimension.code + '_' + column.name.toLocaleLowerCase();
        // just return name and total questions for orphan dimension
        if (dimension.status === undefined &&
            column.name !== DimensionViewColumnHelper_1.dimensionNameColumn.name &&
            column.name !== DimensionViewColumnHelper_1.selectedQuestionsColumn.name &&
            column.name !== DimensionViewColumnHelper_1.totalQuestionsColumn.name &&
            column.name !== DimensionViewColumnHelper_1.sourceTypeColumn.name) {
            return React.createElement(DimensionTableColumn_1.DimensionTableColumn, { key: key });
        }
        switch (column.name) {
            case DimensionViewColumnHelper_1.dimensionNameColumn.name:
                return React.createElement(DimensionNameCell, { key: key }, dimension.name);
            case DimensionViewColumnHelper_1.sourceTypeColumn.name: {
                var text = lodash_1.default.isEqual(dimension.sourceType, models_1.SourceType.KincentricLibrary)
                    ? 'Kincentric Library'
                    : lodash_1.default.isEqual(dimension.sourceType, models_1.SourceType.ClientLibrary)
                        ? 'My Company Library'
                        : 'Custom';
                return React.createElement(DimensionTableColumn_1.DimensionTableColumn, { key: key }, text);
            }
            case DimensionViewColumnHelper_1.publicationStatusColumn.name:
                return React.createElement(DimensionTableColumn_1.DimensionTableColumn, { key: key }, dimension.status);
            case DimensionViewColumnHelper_1.dimensionTypeColumn.name:
                return (React.createElement(DimensionTableColumn_1.DimensionTableColumn, { key: key }, dimension.dimensionType === enum_1.DimensionType.Dimension ? 'Dimension' : 'Index'));
            case DimensionViewColumnHelper_1.keyMetricColumn.name:
                return React.createElement(DimensionTableColumn_1.DimensionTableColumn, { key: key }, dimension.isScored ? 'Yes' : 'No');
            case DimensionViewColumnHelper_1.languagesColumn.name:
                return (React.createElement(DimensionTableColumn_1.DimensionTableColumn, { key: key },
                    this.props.dimensionLanguages.length,
                    React.createElement(common_1.ModalOpenButton, { id: dimension.dimensionId, text: dimension.name, OpenModalCallback: this.props.DimensionLanguagesModalOpen })));
            case DimensionViewColumnHelper_1.totalQuestionsColumn.name:
                return React.createElement(DimensionCountCell, { key: key }, this.props.questions.length);
            case DimensionViewColumnHelper_1.selectedQuestionsColumn.name:
                return (React.createElement(DimensionCountCell, { key: key },
                    React.createElement(aon_tws_common_ui_1.ThresholdPill, { count: this.props.questions.length })));
            case DimensionViewColumnHelper_1.allEnabledLanguagesColumn.name: {
                var missingLanguages = this.GetMissingLanguages();
                var tooltipLangId = this.props.dimension.name + '_allChosenLanguages';
                return (React.createElement(DimensionTableColumn_1.DimensionTableColumn, { key: key }, missingLanguages.length === 0 ? (React.createElement(aon_tws_common_ui_1.Icon, { name: 'yes' })) : (React.createElement(React.Fragment, null,
                    missingLanguages.length + " missing ",
                    React.createElement(aon_tws_common_ui_1.Tooltip, { id: tooltipLangId, iconName: 'error', contentType: 'jsx' },
                        React.createElement("div", null,
                            React.createElement("p", null,
                                React.createElement("strong", null, contentConstants_1.default.MISSING_LANGUAGES_TOOLTIP_TITLE_TEXT)),
                            React.createElement("ul", null, missingLanguages.map(function (id, liKey) {
                                var culture = _this.props.availableCultures.find(function (c) { return c.name === id; });
                                return React.createElement("li", { key: liKey }, culture ? culture.displayText : id);
                            })),
                            React.createElement("br", null),
                            contentConstants_1.default.MISSING_LANGUAGES_TOOLTIP_REMINDER_TEXT))))));
            }
            case DimensionViewColumnHelper_1.actionsColumn.name:
                return (React.createElement(DimensionTableColumn_1.DimensionTableColumn, { key: key, columnName: DimensionViewColumnHelper_1.actionsColumn.name },
                    React.createElement(aon_tws_common_ui_1.ActionMenuWrapper, null, this.props.dimension.shouldDisableEdit ? (React.createElement(aon_tws_common_ui_1.DropdownMenuItem, { onClick: function () { return _this.props.CopyCustomDimension(_this.props.dimension, _this.props.questions); } }, contentConstants_1.default.DIMENSION_TABLE_DROPDOWN_COPY_CUSTOM)) : (React.createElement(React.Fragment, null,
                        React.createElement(aon_tws_common_ui_1.DropdownMenuItem, { onClick: function () { return _this.props.CopyCustomDimension(_this.props.dimension, _this.props.questions); } }, contentConstants_1.default.DIMENSION_TABLE_DROPDOWN_COPY),
                        React.createElement(aon_tws_common_ui_1.DropdownMenuItem, { onClick: function () {
                                _this.props.ShowEditCustomDimension(_this.props.dimension.dimensionId);
                                _this.props.GetDimension(_this.props.dimension.dimensionId);
                            } }, contentConstants_1.default.DIMENSION_TABLE_DROPDOWN_EDIT),
                        this.props.RemoveCustomDimension && (React.createElement(aon_tws_common_ui_1.DropdownMenuItem, { onClick: function () { return _this.props.RemoveCustomDimension(_this.props.dimension.dimensionId); } }, contentConstants_1.default.DIMENSION_TABLE_DROPDOWN_DELETE)))))));
            default:
                return React.createElement(DimensionTableColumn_1.DimensionTableColumn, { key: key });
        }
    };
    DimensionRow.prototype.GetMissingLanguages = function () {
        var dimensionLanguages = this.props.dimension.translations.map(function (t) { return t.cultureCode; });
        return this.props.supportedCultures.filter(function (id) { return dimensionLanguages.indexOf(id) === -1; });
    };
    DimensionRow.prototype.ToggleExpanded = function () {
        if (this.props.FetchQuestions && this.props.dimension.dimensionId) {
            this.props.FetchQuestions(this.props.dimension.dimensionId);
        }
        this.setState({ isExpanded: !this.state.isExpanded });
    };
    return DimensionRow;
}(React.PureComponent));
exports.DimensionRow = DimensionRow;
var templateObject_1, templateObject_2, templateObject_3;
